// Generated by scripts/catalog/build_web_search_catalog.py.
export const WEB_CATALOG = {
  artifactUrl:
    '/app/artifacts/catalog/sha256-b328e6e04ebb4f082ef0600b110bf0868163cce785b247a1084a83fd114522ed/catalog.json',
  attribution:
    'Railway topology © OpenStreetMap contributors, ODbL 1.0; country extract provided by Geofabrik GmbH; modified for Der Maschinfuehrer.',
  catalogVersion: 'sha256-b328e6e04ebb4f082ef0600b110bf0868163cce785b247a1084a83fd114522ed',
  documentCount: 6191,
  formatVersion: '1.0.0',
} as const;
